document.addEventListener('DOMContentLoaded', () => {
    const accordionContainers = document.querySelectorAll('.custom-container');

    accordionContainers.forEach(container => {
        const sections = container.querySelectorAll('.section');

        sections.forEach(section => {
            section.addEventListener('click', () => {
                if (section.classList.contains('grow')) {
                    return;
                }

                const sectionColor = section.dataset.sectionColor;

                sections.forEach(s => {
                    const textElementToHide = s.querySelector('.main-text');
                    if (textElementToHide) {
                        textElementToHide.classList.remove('show', 'animate');
                        textElementToHide.classList.add('hide');
                    }

                    s.classList.replace('grow', 'shrink');
                    s.setAttribute('aria-expanded', 'false');

                    if (s.dataset.sectionColor) {
                        s.style.background = s.dataset.sectionColor;
                    }


                    s.classList.remove('shadow-dark');

                });

                section.classList.replace('shrink', 'grow');
                section.setAttribute('aria-expanded', 'true');

                section.classList.add('shadow-dark');

                const targetTextId = section.querySelector('button').getAttribute('aria-controls');
                const targetText = document.getElementById(targetTextId);

                setTimeout(() => {
                    if (targetText) {
                        targetText.classList.remove('hide');
                        targetText.classList.add('show', 'animate');
                    }
                }, 300); // Délai pour correspondre à la transition CSS
            });
        });


        const initialSection = container.querySelector('.section[data-section-index="0"]');
        if (initialSection) {

            initialSection.click();
        }
    });
});